    (function () {

      var released = false;

      function releaseAll() {
        if (released) return;
        released = true;

        if (window.__jazminCreate) {
          document.createElement = window.__jazminCreate;
        }

        if (window.__jazminObserver) {
          window.__jazminObserver.disconnect();
        }

        var held = window.__jazminHeld || [];
        held.forEach(function (item) {
          var fresh = window.__jazminCreate('script');
          Array.from(item.el.attributes).forEach(function (attr) {
            fresh.setAttribute(attr.name, attr.value);
          });
          fresh.async = true;
          fresh.src = item.src;
          document.head.appendChild(fresh);
        });

        document.querySelectorAll('script[type="inert"]').forEach(function (old) {
          var src = old.getAttribute('data-lazy');
          if (!src) return;
          var fresh = window.__jazminCreate('script');
          Array.from(old.attributes).forEach(function (attr) {
            if (attr.name !== 'type' && attr.name !== 'data-lazy') {
              fresh.setAttribute(attr.name, attr.value);
            }
          });
          fresh.async = true;
          fresh.src = src;
          old.remove();
          document.head.appendChild(fresh);
        });

        document.querySelectorAll('iframe[data-lazy]').forEach(function (f) {
          f.src = f.getAttribute('data-lazy');
          f.removeAttribute('data-lazy');
        });

        document.dispatchEvent(new CustomEvent('asyncLazyLoad'));

        console.log('[Jazmin] Scripts released. Count: ' + (window.__jazminHeld || []).length);
      }

      var events = [
        'mousedown', 'mousemove', 'keydown',
        'scroll', 'touchstart', 'click', 'touchmove'
      ];

      function onInteraction() {
        events.forEach(function (e) {
          window.removeEventListener(e, onInteraction, false);
        });
        releaseAll();
      }

      events.forEach(function (e) {
        window.addEventListener(e, onInteraction, false);
      });

      window.addEventListener('load', function () {
        setTimeout(releaseAll, 10000);
      });

    })();
    